import { render, staticRenderFns } from "./SelectPagination.vue?vue&type=template&id=29747640&"
import script from "./SelectPagination.vue?vue&type=script&lang=js&"
export * from "./SelectPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports